export default __webpack_public_path__ + "static/media/v1.9817562e.mp4";